import "../css/AboutUs.css";
import Footerlanding from '../landing/Footerlanding';
import Navbarlanding from '../landing/Navbarlanding';

    const services = [
    { title: "Digital Banking", desc: "Seamless online banking experience for individuals and businesses.", icon: "💳" },
    { title: "AI Solutions", desc: "AI-powered analytics and automation to optimize banking operations.", icon: "🤖" },
    { title: "Cyber Security", desc: "Advanced security protocols to protect data and transactions.", icon: "🔒" },
    { title: "Mobile & Internet Banking", desc: "User-friendly mobile apps and online platforms.", icon: "📱" },
    { title: "Cloud Banking", desc: "Scalable cloud-based banking infrastructure.", icon: "☁️" },
    { title: "Fintech Integration", desc: "Seamless integration with third-party fintech services.", icon: "🔗" },
    ];

    const team = [
    { name: "Shivam Kumar", role: "CEO", img: "https://via.placeholder.com/150" },
    { name: "Rahul Raj", role: "CTO", img: "https://via.placeholder.com/150" },
    { name: "Anita Singh", role: "Lead Developer", img: "https://via.placeholder.com/150" },
    { name: "Rohit Verma", role: "Head of AI Solutions", img: "https://via.placeholder.com/150" },
    ];

    const testimonials = [
    { name: "Rajesh Sharma", feedback: "Tech Vision transformed our banking platform completely!" },
    { name: "Priya Verma", feedback: "Secure, fast, and reliable fintech solutions for our business." },
    { name: "Ankit Jain", feedback: "AI solutions reduced operational costs by 30%." },
    ];

    const caseStudies = [
    { bank: "Global Bank", challenge: "Outdated banking system.", solution: "Migrated to digital banking platform.", outcome: "Improved efficiency by 50%." },
    { bank: "Future Finance", challenge: "Fraud detection issues.", solution: "Implemented AI security protocols.", outcome: "Zero security breaches in 2 years." },
    ];

    function AboutUs() {
    return (
        <div className="font-sans text-gray-800">
        {/* Navbar */}
        <Navbarlanding />

        {/* Hero Section */}
        <section className="hero relative bg-gradient-to-r from-green-500 to-green-700 text-white py-32 px-6 flex flex-col justify-center items-center text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Empowering Banks with Smart, Secure & Scalable Solutions</h1>
            <p className="text-lg md:text-xl mb-6 max-w-xl mx-auto">
            Tech Vision Banking Solutions integrates advanced technology and financial expertise to deliver cutting-edge digital banking platforms.
            </p>
            <button className="bg-white text-green-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition">
            Learn More
            </button>
        </section>

        {/* Who We Are */}
        <section className="py-20 px-6 bg-gray-50 text-center">
            <h2>Who We Are</h2>
            <p className="max-w-2xl mx-auto mb-6">
            Tech Vision Banking Solutions was founded to drive innovation in the banking industry through AI, cloud computing, and secure fintech platforms. We focus on creating scalable, customer-centric, and intelligent banking systems.
            </p>
            <img src="https://via.placeholder.com/900x400" alt="Team working" className="mx-auto rounded-lg shadow-lg" />
        </section>

        {/* Mission, Vision & Values */}
        <section className="py-20 px-6 text-center bg-white">
            <h2>Mission, Vision & Core Values</h2>
            <div className="mvv-grid flex flex-col md:flex-row justify-center gap-8">
            <div className="mvv-card bg-gray-50 p-8 rounded-lg shadow hover:shadow-lg transition">
                <h3 className="text-xl font-semibold mb-4">Mission</h3>
                <p>Deliver intelligent, secure banking solutions to enhance customer experiences and operational efficiency.</p>
            </div>
            <div className="mvv-card bg-gray-50 p-8 rounded-lg shadow hover:shadow-lg transition">
                <h3 className="text-xl font-semibold mb-4">Vision</h3>
                <p>Become the most trusted and innovative fintech provider globally, shaping the future of digital banking.</p>
            </div>
            <div className="mvv-card bg-gray-50 p-8 rounded-lg shadow hover:shadow-lg transition text-left">
                <h3 className="text-xl font-semibold mb-4">Core Values</h3>
                <ul className="list-disc list-inside">
                <li>Innovation & Technology</li>
                <li>Customer-Centric Approach</li>
                <li>Trust & Security</li>
                <li>Collaboration & Excellence</li>
                </ul>
            </div>
            </div>
        </section>

        {/* Banking Solutions */}
        <section className="py-20 px-6 bg-gray-50 text-center">
            <h2>Our Banking Solutions</h2>
            <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {services.map((service, index) => (
                <div key={index} className="service-card bg-white p-6 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105">
                <div className="text-5xl mb-4">{service.icon}</div>
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p>{service.desc}</p>
                </div>
            ))}
            </div>
        </section>

        {/* Achievements */}
        <section className="py-20 px-6 text-center">
            <h2>Our Achievements</h2>
            <div className="achievements flex flex-col md:flex-row justify-center gap-12 text-xl font-semibold">
            <div>
                <p className="counter text-green-500">500+</p>
                <p>Projects Completed</p>
            </div>
            <div>
                <p className="counter text-green-500">50+</p>
                <p>Awards & Recognitions</p>
            </div>
            <div>
                <p className="counter text-green-500">100k+</p>
                <p>Happy Customers</p>
            </div>
            <div>
                <p className="counter text-green-500">20+</p>
                <p>Banks Served</p>
            </div>
            </div>
        </section>

        {/* Case Studies */}
        <section className="py-20 px-6 bg-gray-50 text-center">
            <h2>Success Stories</h2>
            <div className="grid md:grid-cols-2 gap-8 max-w-6xl mx-auto">
            {caseStudies.map((caseStudy, index) => (
                <div key={index} className="case-card bg-white p-6 rounded-lg shadow hover:shadow-lg transition flex-1 text-left">
                <h3 className="text-xl font-semibold mb-2">{caseStudy.bank}</h3>
                <p><strong>Challenge:</strong> {caseStudy.challenge}</p>
                <p><strong>Solution:</strong> {caseStudy.solution}</p>
                <p><strong>Outcome:</strong> {caseStudy.outcome}</p>
                </div>
            ))}
            </div>
        </section>

        {/* Testimonials */}
        <section className="py-20 px-6 bg-white text-center">
            <h2>Testimonials</h2>
            <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {testimonials.map((test, index) => (
                <div key={index} className="testimonial-card bg-gray-50 p-6 rounded-lg shadow hover:shadow-lg transition">
                <p className="italic mb-4">"{test.feedback}"</p>
                <p className="font-semibold">{test.name}</p>
                </div>
            ))}
            </div>
        </section>

        {/* Team */}
        <section className="py-20 px-6 text-center bg-gray-50">
            <h2>Meet Our Team</h2>
            <div className="grid md:grid-cols-4 gap-8 max-w-6xl mx-auto">
            {team.map((member, index) => (
                <div key={index} className="team-card flex flex-col items-center bg-white p-6 rounded-lg shadow hover:shadow-lg transition transform hover:scale-105">
                <img src={member.img} alt={member.name} className="w-32 h-32 rounded-full mb-4" />
                <h3 className="text-xl font-semibold">{member.name}</h3>
                <p className="text-gray-500">{member.role}</p>
                </div>
            ))}
            </div>
        </section>

        {/* Call to Action */}
        <section className="cta py-20 px-6 bg-green-500 text-white text-center rounded-lg mx-6 md:mx-32 my-12">
            <h2 className="text-3xl font-bold mb-6">Ready to Transform Your Banking Experience?</h2>
            <p className="mb-6 max-w-xl mx-auto">Get in touch with us today for a free consultation and explore how Tech Vision can innovate your banking solutions.</p>
            <button className="bg-white text-green-700 font-semibold px-6 py-3 rounded-lg hover:bg-gray-100 transition">
            Contact Us
            </button>
        </section>

        {/* Footer */}
        <Footerlanding />
        </div>
    );
    }

    export default AboutUs;